import { atom } from "recoil"

// Save selected row ids
export const exchangeRowIdsState = atom({
  key: "exchangeRowIdsState",
  default: {},
})

// Save old package list
export const exchangePackagesState = atom({
  key: "exchangePackagesState",
  default: [],
})
